import { Component } from '@angular/core';

@Component({
  selector: 'app-site-headers',
  standalone: true,
  imports: [],
  templateUrl: './site-headers.component.html',
  styleUrl: './site-headers.component.scss'
})
export class SiteHeadersComponent {

}
